export const locale = {
    lang: 'en',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'Rate': 'Amount',
            'CoworkerAwaitedStatus': 'If the case is in a pending status and if the amount is greater than DKK "amount", request an advance payment',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'Buttons': {
            'Save': 'Save',
        }
    }
};